<template>
  <main class="kyc-page">
    <AppNavBar backgroundColor="#fff" :title="t('card.kycTitle')" />

    <section class="notice-card">
      <div class="notice-card__title">
        <div data-strong>{{ t("card.kycVerify") }}</div>
      </div>
      <div class="notice-row">
        <i />
        <p>{{ t("card.kycRequirement1") }}</p>
      </div>
    </section>

    <div class="action-bar">
      <van-button
        block
        round
        type="primary"
        @click="router.push('/card/kyc/address')"
      >
        {{ t("card.verifyNow") }}
      </van-button>
    </div>
  </main>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const { t } = useI18n();
const router = useRouter();
</script>

<style scoped lang="scss">
.kyc-page {
  min-height: var(--app-viewport-height);
  padding: 20px 20px 36px;
  background: #ffffff;
}

.notice-card {
  padding: 15px;
  border-radius: 8px;
  background: #f4f5f6;

  &__title {
    padding: 12px 0;
    border-bottom: 1px solid #dfe3ea;
    display: flex;
    [data-strong] {
      color: #000000;
      font-size: 16px;
      font-weight: 700;
    }
  }
}

.notice-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 15px;

  i {
    flex: 0 0 10px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--wp-color-brand-1);
  }

  p {
    margin: 0;
    color: #666666;
    font-size: 12px;
    line-height: 18px;
  }
}

.action-bar {
  padding-top: 24px;
}
</style>
